/**
 * Import Validation Configurations
 *
 * This file contains validation configurations for all import pages.
 * Each config defines validation rules for fields in a declarative way.
 */

import { SharedMsgHelper } from '../utils/SharedMsgHelper';
import { ValidationHelper } from '../utils/ValidationHelper';

export interface FieldValidation {
    required?: boolean;
    type?: 'number' | 'integer' | 'date' | 'enum';
    enumValues?: string[];
    customValidator?: (value: any) => string | null; // returns error message or null if valid
}

export interface ImportValidationConfig {
    [fieldName: string]: FieldValidation;
}

// ============================================================================
// DirectOrder Checkpoint Import Validation
// ============================================================================
export const DirectOrderCheckpointImportValidation: ImportValidationConfig = {
    directOrderNumber: {
        required: true,
        customValidator: (value) => {
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                return SharedMsgHelper.getNotAlphanumericErrMsg;
            }
            return null;
        }
    },
    checkpointTimeUtc: {
        required: true,
        customValidator: (value) => {
            if (!ValidationHelper.isIsoUtcTimeString(value)) {
                return SharedMsgHelper.getInvalidcheckpointTimeUtcFormatErrMsg;
            }
            return null;
        }
    },
    tag: { required: true },
    subTag: { required: true },
    message: { required: true }
};

// ============================================================================
// Update DirectOrder Last Mile Reference Import Validation
// ============================================================================
export const UpdateLastMileReferenceImportValidation: ImportValidationConfig = {
    directOrderNumber: {
        required: true,
        customValidator: (value) => {
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                return SharedMsgHelper.getNotAlphanumericErrMsg;
            }
            return null;
        }
    },
    directOrderCourierCode: { required: true },
    carrierReference: {
        required: true,
        customValidator: (value) => {
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                return SharedMsgHelper.getNotAlphanumericErrMsg;
            }
            return null;
        }
    }
};
